// extracted by mini-css-extract-plugin
module.exports = {"quoteblock":"Quote_quoteblock__ip1G6","quoteline":"Quote_quoteline__Lzs9o","quotetext":"Quote_quotetext__TJIdx"};